
import params from '@synergycms_core/store/customer/paramsActions';
import moment from 'moment';

import { momentLangCodes, langCodeCorrector } from '@synergycms_core/utils/api';
import loggerGetter from '@synergycms_core/utils/logger';
import { toLower } from 'ramda';

export default {
  PARAMS: params,
  LANG_INFO: {
    GET: langInfo => {
      moment.locale(toLower(momentLangCodes(langCodeCorrector(langInfo.code))));
      langInfo.code = langCodeCorrector(langInfo.code);
      return langInfo;
    }
  },
  WEB_TYPE: {
    GET: webType => {
      return webType;
    }
  },
  CURRENT_HOTEL: {
    SET: hotelId => {
      return (dispatch, getState) => {
        const store = getState();
        const currentHotelId = hotelId
          ? hotelId.toString()
          : store.getIn(['customer', 'params', 'params', 'hotelId']).toString() || null;
        loggerGetter(currentHotelId);
        return currentHotelId;
      };
    },
    CLEAR: () => {
      return null;
    }
  }
};